"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _InputIcons = _interopRequireWildcard(require("./Common/InputIcons"));

var _EditButtons = _interopRequireDefault(require("./Common/EditButtons"));

var _ViewInput = _interopRequireDefault(require("./Common/ViewInput"));

var _validate = require("../../../utils/inputValidator/validate");

var _validationTriggers = require("../../../constants/validation/validationTriggers");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _idGenerator = _interopRequireDefault(require("../../../utils/idGenerator"));

var _displayModes = require("../../../constants/displayModes");

var _widths = require("./Common/widths");

var _Input = require("./Input.styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildMask = function buildMask(maskLength) {
  var regexArray = [];

  for (var i = 0; i < maskLength; i++) {
    regexArray.push(/./);
  }

  return regexArray;
};

var defaultMask = buildMask(500);
/**
 * Our standard inputs including disabled and those with error states
 */

var Input = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Input, _React$PureComponent);

  var _super = _createSuper(Input);

  function Input(_props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.innerInput.current.inputElement.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.innerInput.current.inputElement.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var errors = _this.validateInput({
        type: _validationTriggers.CLICK,
        value: e.target.value
      });

      return _this.props.onClick && _this.props.onClick(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      if (e.target.value === _this.props.value) {
        return undefined;
      }

      var errors = _this.validateInput({
        type: _validationTriggers.CHANGE,
        value: e.target.value
      });

      return _this.props.onChange && _this.props.onChange(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var errors = _this.validateInput({
        type: _validationTriggers.BLUR,
        value: e.target.value
      });

      _this.setState({
        focused: false
      });

      return _this.props.onBlur && _this.props.onBlur(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var errors = _this.validateInput({
        type: _validationTriggers.FOCUS,
        value: e.target.value
      });

      _this.setState({
        focused: true
      });

      return _this.props.onFocus && _this.props.onFocus(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      return _this.props.onKeyDown && _this.props.onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (e) {
      return _this.props.onKeyUp && _this.props.onKeyUp(e);
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? undefined : _ref$type,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? _this.props.value : _ref$value;

      var currentErrors = _this.state.errors;

      var errors = _this.validate({
        type: type,
        value: value,
        currentErrors: currentErrors
      });

      var mergedErrors = [].concat(_toConsumableArray(_this.props.errors), _toConsumableArray(errors)).filter(function (item, index, arr) {
        return arr.indexOf(item) === index;
      }).sort();

      _this.setState({
        errors: mergedErrors
      });

      return mergedErrors;
    });

    _defineProperty(_assertThisInitialized(_this), "validateAllRules", function () {
      var value = _this.props.value;
      var currentErrors = _this.state.errors;

      var errors = _this.validate({
        value: value,
        currentErrors: currentErrors
      });

      _this.setState({
        errors: errors
      });

      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditMode", function () {
      var _this$props = _this.props,
          onSave = _this$props.onSave,
          value = _this$props.value;
      var mode = _this.state.mode;

      if (mode === _displayModes.displayModes.viewing) {
        _this.setState({
          mode: _displayModes.displayModes.editing
        }, function () {
          var theInput = _this.innerInput.current && _this.innerInput.current.inputElement || // masked input
          _this.innerInput.current && _this.innerInput.current || // vanilla input
          _this.innerInput; // textArea

          if (theInput.createTextRange) {
            var part = theInput.createTextRange();
            part.move('character', 0);
            part.select();
          } else if (theInput.setSelectionRange) {
            theInput.setSelectionRange(0, -1);
          }

          theInput.focus();
        });
      } else {
        var errors = _this.validateInput({
          type: _validationTriggers.BLUR,
          value: value
        });

        if (!errors.length) {
          _this.setState({
            mode: _displayModes.displayModes.viewing,
            focused: false
          }, function () {
            onSave && onSave({
              target: {
                value: value
              }
            }); // eslint-disable-line no-unused-expressions
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "errorMsg", function () {
      var errors = _this.state.errors; // The `castArray` call here is included as a defense against type drift

      return (0, _lodash.castArray)(errors).map(function (error) {
        return /*#__PURE__*/_react.default.createElement(_Input.ErrorMessage, {
          "data-test-id": "input-error-message",
          key: "error-msg-".concat(error)
        }, error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "determineInputType", function () {
      var _this$props2 = _this.props,
          aligninput = _this$props2.aligninput,
          autoFocus = _this$props2.autoFocus,
          characterLimit = _this$props2.characterLimit,
          children = _this$props2.children,
          className = _this$props2.className,
          dataTestId = _this$props2.dataTestId,
          disabled = _this$props2.disabled,
          displayName = _this$props2.displayName,
          guide = _this$props2.guide,
          id = _this$props2.id,
          inputType = _this$props2.inputType,
          inputWidth = _this$props2.inputWidth,
          leftIcons = _this$props2.leftIcons,
          maskForInput = _this$props2.mask,
          multiLine = _this$props2.multiLine,
          name = _this$props2.name,
          rightIcons = _this$props2.rightIcons,
          validationRules = _this$props2.validationRules,
          value = _this$props2.value,
          zeroPadding = _this$props2.zeroPadding,
          onClick = _this$props2.onClick,
          onChange = _this$props2.onChange,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          onKeyUp = _this$props2.onKeyUp,
          onSave = _this$props2.onSave,
          props = _objectWithoutProperties(_this$props2, ["aligninput", "autoFocus", "characterLimit", "children", "className", "dataTestId", "disabled", "displayName", "guide", "id", "inputType", "inputWidth", "leftIcons", "mask", "multiLine", "name", "rightIcons", "validationRules", "value", "zeroPadding", "onClick", "onChange", "onBlur", "onFocus", "onKeyUp", "onSave"]);

      var _this$state = _this.state,
          mask = _this$state.mask,
          mode = _this$state.mode;
      var inViewMode = mode === _displayModes.displayModes.viewing || mode === _displayModes.displayModes.viewOnly;

      if (multiLine) {
        return /*#__PURE__*/_react.default.createElement(_Input.StyledTextArea, _extends({
          aligninput: aligninput,
          autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          ,
          "data-test-id": "input-edit-mode-input",
          disabled: disabled,
          id: id,
          inviewmode: inViewMode.toString(),
          name: name || id,
          inputRef: function inputRef(tag) {
            return _this.innerInput = tag;
          } // eslint-disable-line
          ,
          value: value,
          zeropadding: zeroPadding.toString() // events
          ,
          onBlur: _this.handleBlur,
          onChange: _this.handleChange,
          onClick: _this.handleClick,
          onFocus: _this.handleFocus,
          onKeyDown: _this.handleKeyDown,
          onKeyUp: _this.handleKeyUp
        }, props));
      }

      if (maskForInput || characterLimit >= 0) {
        return /*#__PURE__*/_react.default.createElement(_Input.StyledMaskedInput, _extends({
          aligninput: aligninput,
          autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          ,
          "data-test-id": "input-edit-mode-input",
          disabled: disabled,
          guide: guide,
          id: id,
          inviewmode: inViewMode.toString(),
          mask: mask,
          name: name || id,
          ref: _this.innerInput,
          type: inputType,
          value: value,
          zeropadding: zeroPadding.toString() // events
          ,
          onBlur: _this.handleBlur,
          onChange: _this.handleChange,
          onClick: _this.handleClick,
          onFocus: _this.handleFocus,
          onKeyDown: _this.handleKeyDown,
          onKeyUp: _this.handleKeyUp
        }, props));
      }

      return /*#__PURE__*/_react.default.createElement(_Input.StyledPlainInput, _extends({
        aligninput: aligninput,
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        "data-test-id": "input-edit-mode-input",
        disabled: disabled,
        id: id,
        inviewmode: inViewMode.toString(),
        name: name || id,
        ref: _this.innerInput // eslint-disable-line
        ,
        type: inputType,
        value: value,
        zeropadding: zeroPadding.toString() // events
        ,
        onBlur: _this.handleBlur,
        onChange: _this.handleChange,
        onClick: _this.handleClick,
        onFocus: _this.handleFocus,
        onKeyDown: _this.handleKeyDown,
        onKeyUp: _this.handleKeyUp
      }, props));
    });

    _this.state = {
      errors: _toConsumableArray(_props.errors),
      focused: false,
      mask: _props.mask,
      mode: _props.mode
    };
    _this.innerInput = _react.default.createRef();
    _this.validate = (0, _validate.validate)({
      displayName: _props.displayName || _props.name,
      rules: _props.validationRules
    });
    return _this;
  }

  _createClass(Input, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props3 = this.props,
          characterLimit = _this$props3.characterLimit,
          mask = _this$props3.mask;

      if (characterLimit !== -1 && !mask) {
        this.setState({
          mask: buildMask(characterLimit)
        });
        /**
         * This next block is to fix a bug in the 'react-text-mask' library as of v.5.4.1.
         *
         * Currently controlled inputs are not supported when the mask property is set to false. By
         * adding a mask property that accepts all input, we're able to circumvent the bug and provide
         * a controlled input for all inputs, and especially those like our autocomplete inputs that
         * require the parent to update the text of the child input.
         *
         * The current length is arbitrary, high enough that we shouldn't run into an issue normally, but
         * not so high as to bog down a page with multiple inputs.
         *
         * Issue link:
         * https://github.com/text-mask/text-mask/issues/806
         *
        */
      } else if (characterLimit === -1 && !mask) {
        this.setState({
          mask: defaultMask
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          displayName = _this$props4.displayName,
          name = _this$props4.name,
          validationRules = _this$props4.validationRules; // todo: look at possibly removing this as we shouldn't be changing validation rules on the fly... i think

      this.validate = (0, _validate.validate)({
        displayName: displayName || name,
        rules: validationRules
      });

      if (!(0, _lodash.isEqual)(prevProps.errors, this.props.errors)) {
        this.validateInput();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          aligninput = _this$props5.aligninput,
          children = _this$props5.children,
          className = _this$props5.className,
          dataTestId = _this$props5.dataTestId,
          disabled = _this$props5.disabled,
          inputWidth = _this$props5.inputWidth,
          leftIcons = _this$props5.leftIcons,
          maskForInput = _this$props5.mask,
          rightIcons = _this$props5.rightIcons,
          value = _this$props5.value,
          zeroPadding = _this$props5.zeroPadding;
      var _this$state2 = this.state,
          errors = _this$state2.errors,
          focused = _this$state2.focused,
          mask = _this$state2.mask,
          mode = _this$state2.mode;
      var inViewMode = mode === _displayModes.displayModes.viewing || mode === _displayModes.displayModes.viewOnly;
      return /*#__PURE__*/_react.default.createElement(_Input.Wrapper, {
        aligninput: aligninput,
        className: className,
        "data-test-id": dataTestId,
        inputWidth: inputWidth
      }, /*#__PURE__*/_react.default.createElement(_Input.InputWrapper, {
        disabled: disabled,
        focused: focused,
        hasErrors: errors.length > 0,
        inputWidth: inputWidth,
        inViewMode: inViewMode
      }, /*#__PURE__*/_react.default.createElement(_InputIcons.default, {
        errors: errors,
        focused: focused,
        icons: leftIcons,
        position: _InputIcons.positions.left,
        zeroPadding: zeroPadding
      }), /*#__PURE__*/_react.default.createElement(_Input.DataWrapper, {
        inputWidth: inputWidth
      }, /*#__PURE__*/_react.default.createElement(_ViewInput.default, {
        aligninput: aligninput,
        inputWidth: inputWidth,
        mask: maskForInput && mask,
        mode: mode,
        value: value,
        zeroPadding: zeroPadding
      }), this.determineInputType()), /*#__PURE__*/_react.default.createElement(_EditButtons.default, {
        disabled: disabled,
        errors: errors,
        mode: mode,
        toggleEditMode: this.toggleEditMode
      }), children, /*#__PURE__*/_react.default.createElement(_InputIcons.default, {
        errors: errors,
        focused: focused,
        icons: rightIcons,
        position: _InputIcons.positions.right,
        zeroPadding: zeroPadding
      })), mode !== _displayModes.displayModes.viewOnly && /*#__PURE__*/_react.default.createElement(_Input.ErrorsWrapper, {
        aligninput: aligninput,
        "data-test-id": "input-errors-wrapper"
      }, errors.length > 0 && this.errorMsg()));
    }
  }]);

  return Input;
}(_react.default.PureComponent);

_defineProperty(Input, "propTypes", {
  /** Alignment of the input area - primarily used when doing split layouts */
  aligninput: _propTypes.default.oneOf([undefined, 'left', 'right', 'center']),

  /** Autofocus flag */
  autoFocus: _propTypes.default.bool,

  /** Character Limit */
  characterLimit: _propTypes.default.number,

  /** Children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** The display name is used when presenting error messages */
  displayName: _propTypes.default.string,

  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Provide a guide over the input that reflects the required format (defaults to false) */
  guide: _propTypes.default.bool,

  /** standard id field */
  id: _propTypes.default.string,

  /** Used to indicate the type of input */
  inputType: _propTypes.default.oneOf([undefined, 'email', 'number', 'password', 'state', 'tel', 'text', 'zipcode']),

  /** width of the input - defaults to our traditional 100% width input */
  inputWidth: _propTypes.default.oneOf([undefined, _widths.inputWidths.default, _widths.inputWidths.fitText]),

  /** Mask for input overlay */
  mask: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.bool, _propTypes.default.func]),

  /** Mode flag
   * - 'editOnly' for single mode, editable
   * - 'viewing' for dual mode, starting in a 'viewing' state
   * - 'viewOnly' for single mode, not editable
   */
  mode: _propTypes.default.oneOf([undefined, _displayModes.displayModes.editOnly, _displayModes.displayModes.viewing, _displayModes.displayModes.viewOnly]),

  /** flag for multi line edit mode */
  multiLine: _propTypes.default.bool,

  /** name reference for label htmlFor */
  name: _propTypes.default.string,
  // ICONS //

  /** Icons or IconButtons to display to the left of the input field. */
  leftIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),

  /** Icons or IconButtons to display to the right of the input field. */
  rightIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),
  // VALIDATION //

  /** Controls when validation is triggered */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),

  /** This is the storage location for the value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** flag to partially remove default padding - used internally */
  zeroPadding: _propTypes.default.bool,
  // EVENTS //

  /** Function to invoke on a blur event */
  onBlur: _propTypes.default.func,

  /** Function to invoke on a change event */
  onChange: _propTypes.default.func,

  /** Function to invoke on a click event */
  onClick: _propTypes.default.func,

  /** Function to invoke on a focus event */
  onFocus: _propTypes.default.func,

  /** Function to invoke on a keyDown event */
  onKeyDown: _propTypes.default.func,

  /** Function to invoke on a keyUp event */
  onKeyUp: _propTypes.default.func,

  /** When toggling between edit and view mode, this optional prop will execute then the user 'commits' the new value */
  onSave: _propTypes.default.func
});

_defineProperty(Input, "defaultProps", {
  aligninput: undefined,
  autoFocus: false,
  characterLimit: -1,
  children: null,
  className: '',
  disabled: false,
  displayName: undefined,
  errors: [],
  guide: false,
  id: (0, _idGenerator.default)(),
  inputType: 'text',
  inputWidth: 'default',
  mask: false,
  mode: _displayModes.displayModes.editOnly,
  multiLine: false,
  name: '',
  validationRules: {},
  value: undefined,
  zeroPadding: false,
  // icons
  leftIcons: [],
  rightIcons: [],
  // events
  onBlur: function onBlur() {},
  onChange: function onChange(e) {
    return e.target.value;
  },
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onSave: function onSave() {}
});

var _default = Input;
exports.default = _default;